<template>
    <div class="card card-custom gutter-b h-100">
        <div class="card-header">
            <div class="card-title">
                Danh sách nhận tiền ngân hàng
            </div>
        </div>
        <!--    body-->
        <div class="card-body">
            <div class="row">
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Thời gian</h4>
                    <el-date-picker
                        v-model="query.range"
                        type="daterange"
                        style="width: 100%"
                        range-separator="-"
                        start-placeholder="Bắt đầu"
                        @change="changeValue"
                        value-format="yyyy-MM-dd"
                        end-placeholder="kết thúc">
                    </el-date-picker>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Ngân hàng</h4>
                    <el-select v-model="query.bank" @change="changeValue" clearable placeholder="Chọn ngân hàng">
                        <el-option v-for="bank in banks" :key="bank.stk"
                                   :label="`${bank.name_bank ? bank.name_bank + ' - ': ''}  ${bank.stk}`"
                                   :value="bank.stk"></el-option>
                    </el-select>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Trạng thái</h4>
                    <el-select v-model="query.status" @change="changeValue" clearable placeholder="Chọn trạng thái">
                        <el-option :value="status.id" :key="status.id" :label="`${status.value}`" v-for="status in statusOption"></el-option>
                    </el-select>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Số điện thoại </h4>
                    <el-input placeholder="Nhập số điện thoại" @input="changeValue" clearable v-model="query.phone"></el-input>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Nội dung mã giao dịch </h4>
                    <el-input placeholder="Nhập nội dung mã giao dịch" clearable @input="changeValue" v-model="query.keyword" ></el-input>
                </div>
            </div>
            <h4 class="mt-4"> Tổng số tiền: <span class="text-danger">{{ total_amount | formatVND }}</span></h4>
            <!--      table-->
            <div class="mt-4 table-responsive">
                <table class="table table-bordered text-center table-vertical-center ">
                    <thead>
                    <tr style="background-color: #F8F8F8 ; font-size: 13px">
                        <th>Mã giao dịch</th>
                        <th>Tài khoản ngân hàng nhận</th>
                        <th>Số điện thoại</th>
                        <th>Nội dung chuyển khoản</th>
                        <th>Số tiền</th>
                        <th style="width: 150px">Thời gian nhận</th>
                        <th>Hạng mục</th>
                        <th style="width: 150px">Phân loại</th>
                        <th style="width: 150px">Chi nhánh</th>
                        <th>Ghi chú</th>
                        <th>Hành động</th>
                    </tr>
                    </thead>
                    <tbody v-if="items.length === 0">
                    <tr >
                        <td v-loading="loading"  colspan="11">
                            Không có dữ liệu.
                        </td>
                    </tr>
                    </tbody>
                    <tbody>
                    <tr v-for="(item, index) in items">
                        <td  >{{ item.referenceCode }}</td>
                        <td >
                            <img width="20" :src="publicPath + `${item.bank.toLowerCase()}` + '-icon.png'" alt="">
                            {{ item.bank }} - <b>{{ item.stk }}</b>
                        </td>
                        <td>{{ item.phone }}</td>
                        <td align="start">{{ item.description }}</td>
                        <td>{{ item.amount | formatVND }}</td>
                        <td>{{ item.time }}</td>
                        <td>
                            <el-tag v-if="getStatusById(item.payments_status)" :type="getStatusById(item.payments_status).type"
                                effect="dark">
                                {{ getStatusById(item.payments_status).label }}
                            </el-tag>
                        </td>
                        <td>{{ item.category_string }}</td>
                        <td>{{ item.branch_name }}</td>
                        <td>{{ item.note }}</td>
                        <td>
                            <div class="d-flex">
                                <i v-if="[0,2,3,4,5].includes(item.payments_status)"  @click="openDialogEdit(item.id)" style="color: orange; font-size: 24px; cursor: pointer; margin-right: 12px; cursor: pointer;" size="large" class="el-icon-edit-outline "></i>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="mb-0 d-flex flex-row-reverse mr-10">
            <p class="mb-0">Tổng số bản ghi: <span class="text-primary ">{{total}}</span></p>
        </div>
        <div class="edu-paginate mx-auto text-center mt-10 ">
            <paginate
                v-model="page"
                :page-count="last_page"
                :page-range="3"
                :margin-pages="1"
                :click-handler="clickCallback"
                :prev-text="'Trước'"
                :next-text="'Sau'"
                :container-class="'pagination b-pagination'"
                :pageLinkClass="'page-link'"
                :next-link-class="'next-link-item'"
                :prev-link-class="'prev-link-item'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :page-class="'page-item'"
            >
            </paginate>
        </div>
        <el-dialog class="type-transaction" title="Phân loại log nhận tiền"  width="30%" :visible.sync="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form"  >
                <el-form-item label="Phân loại"  prop="category">
                    <el-select v-model="form.category" clearable filterable placeholder="Chọn loại log nhận tiền"
                               style="width: 100%">
                        <el-option :label="item.label" :key="item.id" v-for="(item) in typeOptions" :value="item.id"></el-option>

                    </el-select>
                </el-form-item>
              <el-form-item label="Chi nhánh">
                <el-select v-model="form.branch_id" clearable style="width: 100%" placeholder="Chọn chi nhánh">
                  <el-option :label="item.name" :key="item.id" v-for="(item) in branchs" :value="item.id"></el-option>

                </el-select>
              </el-form-item>
                <el-form-item label="Ghi chú" >
                    <el-input type="textarea" maxlength="200" show-word-limit v-model="form.note" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Đánh dấu đã xử lý" prop="status">
                    <el-select v-model="form.status" style="width: 100%" placeholder="Chọn trạng thái xử lý">
                        <el-option label="Đã xử lý" value="4"></el-option>
                        <el-option label="Chưa xử lý" value="5"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Hủy bỏ</el-button>
                <el-button :loading="loadingSave" style="background: #5D04B0; color: white" @click="submitForm('form')" >Xác nhận</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {AUDIT_GET_LIST, AUDIT_UPDATE_DETAIL} from "@/core/services/store/audit/audit.module";
import {AuditModel} from "./Models/AuditModel";
import {GET_BRANCHES_EDUTALK} from "../../../core/services/store/center/branch.module";


export default {
    name: "TransactionBank",
    data() {
        return {
            publicPath: process.env.VUE_APP_BASE_URL + '/icons/',
            loading: false,
            total_amount: 0,
            query: {
                range: null,
                bank: null,
                status: null,
                phone: null,
                keyword: null,
            },
            banks: [
                {"name_bank": "", "stk": "PAYOO"},
                {"name_bank": "ACB", "stk": "980668866"},
                {"name_bank": "ACB", "stk": "14042307"},
                {"name_bank": "ACB", "stk": "77466888"},
                {"name_bank": "ACB", "stk": "789996668888"},
                {"name_bank": "ACB", "stk": "266888088"},
                {"name_bank": "MBBank", "stk": "3996999699999"},
                {"name_bank": "MBBank", "stk": "66822888888"},
                {"name_bank": "MBBank", "stk": "4666999666999"},
            ],
            statusOption: [
                {"id": -1, "value": "Tất cả"},
                {"id": 1, "value": "Đã nạp"},
                {"id": 2, "value": "Chưa nạp"},
                {"id": 3, "value": "Sai số tiền"},
                {"id": 4, "value": "Đã xử lý"},
                {"id": 0, "value": "Chưa xử lý"},
            ],
            paymentsStatus: [
                {id: -1,type: '', label: ''},
                {id: 1, type: 'success', label: 'Đã nạp'},
                {id: 2, type: 'info', label: 'Chưa nạp'},
                {id: 3, type: 'danger', label: 'Sai số tiền'},
                {id: 4, type: 'primary', label: 'Đã xử lý'},
                {id: 5, type: 'info', label: 'Chưa xử lý'},
                {id: 0, type: 'info', label: 'Chưa xử lý'}
            ],
            items: [],
            branchs: [],
            selectedId: 0,
            page: 1,
            last_page: 0,
            total: 0,
            dialogVisible: false,
            loadingSave: false,
            form: {
                category: '',
                note: '',
                status: '',
                id: 0
            },
            rules: {
                category: [
                    {required: true, message: 'Chọn loại log nhận tiền', trigger: 'blur'},
                ],
                note: [
                    { min: 3, max: 200, message: 'Ghi chú tối đa 200 ký tự', trigger: 'blur' }
                ],
                status: [
                    {required: true, message: 'Chọn trạng thái xử lý', trigger: 'blur'},
                ],
            },
            typeOptions: [
                {id: 1, label: "Phí thi Ielts (IDP)"},
                {id: 2, label: "Phí thi lại EC"},
                {id: 3, label: "Phí thi lại IM ( tên các vp IM)"},
                {id: 4, label: "Phí bảo lưu"},
                {id: 5, label: "Phí học lại"},
                {id: 6, label: "Phí  DA bổ trợ cấp tốc"},
                {id: 7, label: "Phí payoo IM ( tên các vp IM)"},
                {id: 8, label: "Học phí Quantum leap"},
                {id: 9, label: "Thanh toán BHXH"},
                {id: 10, label: "Hoàn cọc"},
                {id: 11, label: "Hoàn dư"},
                {id: 12, label: "Học phí IELTS Mentor"},
                {id: 13, label: "Học phí ClassUp"},
                {id: 14, label: "Các chương trình đào tạo"},
                {id: 15, label: "Thiếu thông tin"},
                {id: 16, label: "Lỗi Web"},
                {id: 1000, label: "Khác"},
            ]
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Kiểm toán", route: "" },
            { title: "Danh sách nhận tiền ngân hàng" },
        ]);
        this.query = this.$router.currentRoute.query
        this.getAllEdutalk();
        this.getList();
    },
    methods: {
        openDialogEdit(id) {
            this.form.id = id;
            this.dialogVisible = true;
        },
        getList() {
            this.items = [];
            this.loading = true;
            this.$store.dispatch(AUDIT_GET_LIST, {page: this.page, ...this.query})
                .then((data) => {
                    this.items = data.data.map((report) => new AuditModel(report));
                    this.total = data.pagination.total;
                    this.total_amount = data.total;
                    this.loading = false;
                    this.page = data.pagination.page;
                    this.last_page = data.pagination.last_page;
                })
        },
        changeValue() {
            let query = { ...this.page, ...this.query }
            Object.keys(query).forEach(key => {
                if (query[key] === null || query[key] === undefined || query[key] === '') {
                    delete query[key]
                }
            })
            this.$router.push({
                name: 'transaction-from-banks',
                query: { ...this.page, ...query, t: Date.now() } // force refresh
            })
            this.getList()
        },
        getCategoryById(id)  {
            return this.typeOptions.find((item) => {
                return Number(item.id) === Number(id)
            })
        },
        getStatusById(id)  {
            return this.paymentsStatus.find((item) => {
                return Number(item.id) === Number(id)
            })
        },
        clickCallback(obj) {
            this.page = obj;
            this.getList();
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.updateTransaction()
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        getAllEdutalk() {
          this.$store.dispatch(GET_BRANCHES_EDUTALK, {
            area_id: this.query.area
          }).then((res) => {
            if (!res.error) {
              this.branchs = res.data
            }
          }).catch((e) => {
            console.log(e, 'error')
          });
        },
        updateTransaction() {
            this.loadingSave = true;
            this.$store.dispatch(AUDIT_UPDATE_DETAIL, this.form)
            .then((res) => {
                if (!res.error) {
                    this.items.map((item) => {
                        if (item.id === this.form.id) {
                            item.payments_status = this.form.status;
                            item.category_code = this.form.category;
                            item.category_string = this.getCategoryById(this.form.category).label ?? ''
                        }
                    })
                    this.$bvToast.toast(res.message, {
                        title: 'Phân loại log nhận tiền',
                        variant: 'success',
                        solid: true
                    });
                } else {
                    this.$bvToast.toast(res.message, {
                        title: 'Phân loại log nhận tiền',
                        variant: 'error',
                        solid: true
                    });
                }
                this.dialogVisible = false;
                this.loadingSave = false;
                this.getList();
            })
        },
    }
}
</script>
<style>
.type-transaction .el-dialog__body {
    padding: 10px 20px 30px !important;
}
.type-transaction .el-form-item {
    margin-bottom: 10px !important;
}
.type-transaction .el-form-item__label {
    line-height: unset !important;
}
/* Ẩn dấu * mặc định (ở trước label) */
.type-transaction .el-dialog__body .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::before{
    display: none !important;
}
.type-transaction .el-dialog__body .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::after{
    content: '*';
    color: red; /* màu đỏ theo theme của Element Plus */
    margin-left: 4px;
}
</style>